import { $api } from "@plugins/axios";

const API = {
  createPosition: "/rift-trade/positions",
  closePosition: "/rift-trade/positions/close",
  history: "/rift-trade/positions/history",
  currency: "/rift-trade/currency",
  purchaseRocket: "/rift-trade/purchase-rocket",
  consumeRocket: "/rift-trade/consume-rocket",
};

export const createRiftTradePosition = async (payload) => {
  try {
    const { data } = await $api.post(API.createPosition, payload);
    return data?.data || data;
  } catch (error) {
    console.error("createRiftTradePosition error", error);
    throw error?.response?.data || error;
  }
};

export const closeRiftTradePosition = async (positionId) => {
  try {
    const { data } = await $api.post(API.closePosition, { positionId });
    return data?.data || data;
  } catch (error) {
    console.error("closeRiftTradePosition error", error);
    throw error?.response?.data || error;
  }
};

export const fetchRiftTradeHistory = async () => {
  try {
    const { data } = await $api.get(API.history);
    return data?.data || data;
  } catch (error) {
    console.error("fetchRiftTradeHistory error", error);
    throw error?.response?.data || error;
  }
};

export const fetchRiftTradeCurrency = async () => {
  try {
    const { data } = await $api.get(API.currency);
    return data?.data || data;
  } catch (error) {
    console.error("fetchRiftTradeCurrency error", error);
    throw error?.response?.data || error;
  }
};

export const purchaseRiftTradeRocket = async () => {
  try {
    const { data } = await $api.post(API.purchaseRocket);
    return data?.data || data;
  } catch (error) {
    console.error("purchaseRiftTradeRocket error", error);
    throw error?.response?.data || error;
  }
};

export const consumeRiftTradeRocket = async (amount = 1) => {
  try {
    const { data } = await $api.post(API.consumeRocket, { amount });
    return data?.data || data;
  } catch (error) {
    console.error("consumeRiftTradeRocket error", error);
    throw error?.response?.data || error;
  }
};
